import script from "./PriceRow.vue?vue&type=script&setup=true&lang=js"
export * from "./PriceRow.vue?vue&type=script&setup=true&lang=js"

import "./PriceRow.vue?vue&type=style&index=0&id=071501d0&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-071501d0"]])

export default __exports__